module.exports = __webpack_public_path__ + "static/media/Muli-ExtraLight.8edfed9d.svg";